import { useInstance, createRef, onMounted, nextTick } from 'intact-vue-next';
import { useState } from '../../hooks/useState';
export function useAutoWidth() {
  var instance = useInstance();
  var fakeRef = createRef();
  var width = useState(0);
  instance.watch('value', adjustWidth, {
    inited: true,
    presented: true
  });
  instance.watch('placeholder', adjustWidth, {
    inited: true,
    presented: true
  });
  onMounted(adjustWidth);
  function adjustWidth() {
    if (instance.get('autoWidth')) {
      nextTick(function () {
        var fakeElem = fakeRef.value;
        if (isVisible(fakeElem)) {
          var _width = fakeElem.offsetWidth || 1;
          width.set(_width);
        }
      });
    }
  }
  return {
    fakeRef: fakeRef,
    width: width
  };
}
function isVisible(elem) {
  return elem && (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
}